<div (click)="toggle()" class="d-flex gap-3 m-1 p-2 rounded-2 pointer header background-light-gray align-items-center w-100">
    <div>
        <app-radar-svg class="img-fluid img-max "></app-radar-svg>
    </div>
    @if (onlyAssigned()) {
        <div class="d-flex align-items-center gap-1">
            <span class="fw-bold">{{ name() }}</span>
            <span data-id="assigned-count">({{ assignedAndObservedCount() }}/{{ assignedCount() }})</span>
        </div>
    } @else {
        <div class="d-flex flex-column justify-content-center gap-1">
            <span class="fw-bold">{{ name() }}</span>
            <div class="d-flex gap-1 flex-wrap">
                <span class="flex-none" data-id="total-count">Total: {{ totalCount() }} -</span>
                <span class="flex-none" data-id="assigned-count">Assigned: {{ assignedAndObservedCount() }}/{{ assignedCount( ) }} -</span>
                <span class="flex-none" data-id="not-assigned-count">Not assigned: {{ notAssignedAndObservedCount() }}</span>
            </div>
        </div>
    }
    <div class="action-buttons">
        @if (canRefresh()) {
            <div class="action-button" (click)="refresh($event)">
                <i class="fa-solid fa-lg fa-rotate-right"></i>
            </div>
        }
        @if (canClear()) {
            <div class="action-button" (click)="clear($event)">
                <span class="fw-bold uppercase">Clear</span>
            </div>
        }
    </div>
</div>
<div [ngClass]="{'collapse': !open}">
    @if (animals().length == 0) {
        <div class="text-center p-3 opacity-50">
            No animals
        </div>
    }
    @for (animal of animals(); track animal.id) {
        <div class="card mb-1 ms-1 me-1">
            <app-animal-button
                [id]="animal.id"
                [observingDeviceId]="lastObservationPerAnimalId().get(animal.id)?.id"
                [selectableForAlteration]="false"
                [selectableForDeletion]="false"
                [standalone]="false"/>
        </div>
    }
</div>
